<template>
  <b-container fluid tag="header" class="app-mobile-header">
    <button class="header-nav-toggle" @click="openMobileNav">
      <span class="nav-toggle-bars" />
    </button>
    <span v-if="title" class="header-title-label">{{title}}</span>

    <LogoutLink light />
  </b-container>
</template>

<script>
import { OPEN_NAV } from '@/store/modules/mobileNav';
import LogoutLink from './LogoutLink';

export default {
  name: 'MobileView',

  props: {
    title: {
      type: String,
    },
  },

  methods: {
    openMobileNav() {
      this.$store.dispatch(`mobileNav/${OPEN_NAV}`);
    },
  },

  components: {
    LogoutLink,
  },
};
</script>

<style lang="scss">
.app-mobile-header {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  z-index: 1001;
  display: flex;
  align-items: center;
  padding-top: 16px;
  padding-bottom: 16px;
  background: var(--bf-color-primary);
  color: var(--bf-color-light);
  box-shadow: 0 1px 6px rgba(66, 66, 66, 0.2);

  .header-nav-toggle {
    display: none;
    width: 24px;
    height: 18px;
    position: relative;
    appearance: none;
    background: none;
    border: 0;
    border-radius: 0;
    padding: 0;
    margin: 0;
    cursor: pointer;
  }

  .nav-toggle-bars {
    height: 100%;
    border-top: 2px solid var(--bf-color-light);
    border-bottom: 2px solid var(--bf-color-light);

    &,
    &::before {
      width: 100%;
      display: block;
    }

    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      background: var(--bf-color-light);
      height: 2px;
    }
  }

  .header-title-label {
    display: inline-block;
    font-size: 16px;
    font-family: var(--bf-font-family);
    font-weight: var(--bf-font-weight-semibold);
    // margin-left: 16px;
    flex: 1;
    padding-right: 15px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
